export const weekdayEN = [
    { id: '0', name: 'Monday', shortName: 'Mo' },
    { id: '1', name: 'Tuesday', shortName: 'Tu'  },
    { id: '2', name: 'Wednesday', shortName: 'We'  },
    { id: '3', name: 'Thursday', shortName: 'Th'  },
    { id: '4', name: 'Friday', shortName: 'Fr'  },
    { id: '5', name: 'Saturday', shortName: 'Sa'  },
    { id: '6', name: 'Sunday', shortName: 'Su'  },
  ];
